document.addEventListener("DOMContentLoaded", function() {
    (function () {
        const cookieBar = document.querySelector('[data-cookie-bar]');
        if(!cookieBar)
            return;

        const consentBtn = cookieBar.querySelector('[data-consent-button]');
        consentBtn && consentBtn.addEventListener('click', () => {
            cookieBar.classList.add('is-accepted');
            cookieBar.addEventListener('transitionend', () => {
                cookieBar && cookieBar.parentNode.removeChild(cookieBar);
                document.cookie = "cookie_consent=1";
            }, { once: true })
        });
    }());
});